export default {
  namespaced: true,
  state () {
    return {
      // 商品页搜索关键字
      goodsSort: null,
      taskSort: null,
      rentSort: null,
      eqSort: null,
      isRowShow: false
    }
  },
  getters: {
  },
  mutations: {
    setGoodsSort (state, obj) {
      state.goodsSort = obj
    },
    setTaskSort (state, obj) {
      state.taskSort = obj
    },
    setRentSort (state, obj) {
      state.rentSort = obj
    },
    setEqSort (state, obj) {
      state.eqSort = obj
    },
    setIsRowShow (state, obj) {
      state.isRowShow = obj
    }
  },
  actions: {

  }
}
